export default "__VITE_ASSET__oPnYC2Ld__"